/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by GUillermo Castro Reyes <guillermo.castro@ironbit.com.mx>, September 2022
 */
import React, {StatelessComponent} from 'react';
import {IMatchSeparator} from './matchRibbon'
import { Button } from 'src/packages/components/lib/Button';
import Asset from 'src/requests/apa/Asset';


export interface IMatchTeamProps {
    imageSrc : string,
    score?: string,
    name: string, 
    separator? : string,
    isPlaceholder: boolean
}

export interface IMatchProps {
    id: string;
    row: number,
    column: number,
    title: string;
    subtitle: string;
    matchDate: string;
    separator : IMatchSeparator;
    localTeam: IMatchTeamProps;
    visitorTeam: IMatchTeamProps;
    className?: string;
    data?: any; //TODO: Poner la interfaz respectiva de la fuente de datos
    onClick?: ()=>void;
    navigation?: any;
}
/**
 * A World Cup Match Team
 */
export const MatchTeam: StatelessComponent<IMatchTeamProps> = ({imageSrc, score = '', name, separator, isPlaceholder}) => {
    return <div className='match-team-container'>
        <div>
            <img className={`${score?'image-score':'image-team'} ${!imageSrc ? 'image-placeholder' : ''}`} src={imageSrc || Asset.get('flag_team_placeholder_img')} />
            {score && <span className='mid-dash-score'>{`${separator} ${score}`}</span>}
            <br/>
            <span className={`${score?'team-score':'team'}`}>{name}</span>
        </div>
    </div>
}


const onFocus = (id: string, roundId: string, row: number, column: number): void => {
    const el = document.getElementById(id)!;
    scrollAAF(id, el, roundId, row, column)
}

const scrollAAF = (id:string, el: HTMLElement | null, containerName: string, row: number, column: number) => {

  const menuContainer = document.getElementById(containerName);
  // const mainContainer = document.getElementById('container');

  horizontalScroll(el, menuContainer, column)
  verticalScroll(row)

}

const verticalScroll = (row: number) => {

  const container = document.querySelector(".worldcup-match-container");
  const height = 360;
  
  if(container){
      container.scrollTop = row * height;
  }
}

const horizontalScroll = (el: HTMLElement | null, container: HTMLElement | null, column: number) => {

    const rightMax = 1213;

    if (el && container){
      const [firstElement, ...rest] = el.getClientRects() || [];
      const {left, right} = firstElement;      

      if (right>rightMax){
        //ajuste a la derecha
        container.scrollLeft = container.scrollLeft - (rightMax - right);
      }

      if (left < 40){
        // ajuste a la izquierda
        container.scrollLeft = (column * 202 - 30);
      }
    }
  }

/**
 * A World Cup Match.
 */
export const Match: StatelessComponent<IMatchProps> = ({ 
    id,
    row,
    column,
    title, 
    subtitle, 
    matchDate, 
    separator,
    localTeam, 
    visitorTeam,
    data,
    onClick,
    navigation,
    }) => {
        const {versus, hyphen} = separator;
        return (
            <Button type='button' id={id} dataOptions={...navigation} className='match-button focusable' 
              onClick={()=>{
                  if (onClick){
                      onClick();
                  }
              }}
              onFocus={() => onFocus(id, data, row, column)}
              >
              <div className='match-container'>
                  <div className='title'>{title}</div>
                  <div className='subtitle'>{subtitle}</div>
                  <div className='matchDate'>{matchDate}</div>
                  <MatchTeam {...localTeam} separator={hyphen}/>
                  <div className='versus'>{versus}</div>
                  <MatchTeam {...visitorTeam} separator={hyphen}/>
              </div>
            </Button>
        )        
    }



// WEBPACK FOOTER //
// ./src/mundial/Tabs/Match/match.tsx